export const USER_ROLES = {
    1:'TTSuperAdmin',
    2:'BusinessAdmin',   // This is Customer level user
    3:'PracticeAdmin',
    4:'PracticeUser',
    5:'ConfigAdmin',
}

export const SYSSTEM_USER_ROLES = {
    CONFIG_ADMIN:'Config Admin',
    ASSESSMENT_COACH:'Assessment Coach'
}

export enum RoleMasterEnum {
  PracticeAdmin = 'Practice Admin',
  ConfigAdmin = 'Config Admin'
}